import { render, staticRenderFns } from "./Editions.vue?vue&type=template&id=2fb9b483&"
import script from "./Editions.vue?vue&type=script&lang=js&"
export * from "./Editions.vue?vue&type=script&lang=js&"
import style0 from "./Editions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports